// extracted by mini-css-extract-plugin
export var dropdown = "_tt-0";
export var imageWrapper = "_tt-3";
export var itemNameContainer = "_tt-1";
export var productImage = "_tt-2";
export var spinnerWrapper = "_tt-4";